export interface UserIdentification {
    email: string;
    deliveryPointCode: number;
}

export abstract class UserTrackingService {
    abstract notifyUserHasChanged(identification?: UserIdentification): void;
    abstract registerPushService(): void;
}
